// TODO: This is a component being used as a model. It shouldn't have been placed in a model folder
// Also, a lot about this approach needs to be corrected
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Guid } from 'guid-typescript';
import { Subscription } from 'rxjs';
import { CommonService } from '../services/common.service';

export enum UploadStatus {
  Ready,
  Success,
  AlreadyExists,
  Error,
  CsvError,
  UnknownError,
}

export const UserErrorCode = {
  EmailExists: 'EmailExists',
  UserNameExists: 'UserNameExists',
  userExists: 'User already exists',
  EmailInvalid: 'EmailInvalid',
  RealStaffNumberNotFoundInAmazon: 'RealStaffNumberNotFoundInAmazon',
  AmazonTransporterIDNotAssignedToDSP: 'AmazonTransporterIDNotAssignedToDSP',
  RealStaffNumberAlreadyExistsInCompany: 'RealStaffNumberAlreadyExistsInCompany',
  RealStaffNumberAlreadyExistsInDistributor: 'RealStaffNumberAlreadyExistsInDistributor',
  AmazonConnectivityException: 'AmazonConnectivityException',
  AmazonCouldNotParseBody: 'AmazonCouldNotParseBody',
};

// TODO: Add Angular decorator.
export class UserForm {
  public userForm: UntypedFormGroup;
  private _setIsDriverOnChangeValueSubscription: Subscription;
  private _setIsManagerOnChangeValueSubscription: Subscription;

  constructor(private cService: CommonService) {
    const formControls = this.getFormControls();
    this.userForm = new UntypedFormGroup(formControls);
    this._setIsDriverOnChangeValue();
    this._setIsManagerOnChangeValue();
    this.setRealStaffNumberOnChangeSubscription();
  }

  private getFormControls(): any {
    let baseControls: any = {
      guid: new UntypedFormControl(Guid.create()),
      uploadStatus: new UntypedFormControl(),
      errorMessage: new UntypedFormControl(),
      csvRow: new UntypedFormControl(),
      firstName: new UntypedFormControl(null, [Validators.required]),
      middleName: new UntypedFormControl(),
      lastName: new UntypedFormControl(null, [Validators.required]),
      email: new UntypedFormControl(null, [Validators.required, Validators.pattern(`^(\\S+)@(\\S+)\\.(\\S+)$`)]),
      phoneNumber: new UntypedFormControl(),
      isDriver: new UntypedFormControl({ value: true, disabled: false }),
      isManager: new UntypedFormControl(),
      driverGroupId: new UntypedFormControl({ value: null, disabled: false }),
      managerGroupIds: new UntypedFormControl({ value: null, disabled: true }),
    };

    if (this.cService.userProfile?.companyOptionalSettings?.displayRealStaffNumber === 'TRUE') {
      baseControls = {
        realStaffNumber: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern(this.cService.userProfile?.companyOptionalSettings?.realStaffNumberPattern),
        ]),
        ...baseControls,
      };
    }

    return baseControls;
  }

  get getUserForm(): UntypedFormGroup {
    return this.userForm;
  }

  /**
   * Inizialize Form with data
   * @param initialValues: Object
   */
  inizializeForm(initialValues: object): void {
    if (typeof initialValues == 'object') {
      Object.keys(this.userForm.controls).forEach((key) => {
        if (initialValues.hasOwnProperty(key)) {
          this.userForm.controls[key].setValue(initialValues[key]);
          if (key == 'managerGroupIds') {
            const strings = initialValues[key];
            const nums = strings.map((s) => parseInt(s));
            this.userForm.controls[key].setValue(nums);
          }
        }
      });
      this.userForm.markAllAsTouched();
    }
  }

  /**
   * Set driversGroupsId Validators at isDrivers values change
   */
  _setIsDriverOnChangeValue() {
    this._setIsDriverOnChangeValueSubscription = this.userForm.get('isDriver').valueChanges.subscribe({
      next: (value) => {
        const driverGroupId = this.userForm.get('driverGroupId');

        if (value) {
          driverGroupId.enable();
          this.enableRealStaffValidation();
        }
        if (!value) {
          driverGroupId.reset();
          driverGroupId.disable();
          driverGroupId.setValidators(null);
          this.disableRealStaffValidation();
        }
      },
    });
  }

  private disableRealStaffValidation(): void {
    if (this.cService.userProfile?.companyOptionalSettings?.displayRealStaffNumber === 'TRUE') {
      const realStaffControl = this.userForm.get('realStaffNumber');

      realStaffControl.setValidators(null);
      realStaffControl.disable();
    }
  }

  private enableRealStaffValidation(): void {
    if (this.cService.userProfile?.companyOptionalSettings?.displayRealStaffNumber === 'TRUE') {
      const realStaffControl = this.userForm.get('realStaffNumber');

      realStaffControl.setValidators([
        Validators.required,
        Validators.pattern(this.cService.userProfile?.companyOptionalSettings?.realStaffNumberPattern),
      ]);
      realStaffControl.enable();
    }
  }

  /**
   * Set managerGroupsIds Validators at isManager values change
   */
  _setIsManagerOnChangeValue() {
    this._setIsManagerOnChangeValueSubscription = this.userForm.get('isManager').valueChanges.subscribe({
      next: (value) => {
        const managerGroupIds = this.userForm.get('managerGroupIds');
        if (value) {
          managerGroupIds.enable();
        }
        if (!value) {
          managerGroupIds.reset();
          managerGroupIds.disable();
          managerGroupIds.setValidators(null);
        }
      },
    });
  }

  setRealStaffNumberOnChangeSubscription(): void {
    this.userForm.get('realStaffNumber')?.valueChanges.subscribe({
      next: (value: string): void => {
        this.userForm.get('realStaffNumber').setValue(value?.trim().toUpperCase(), { emitEvent: false });
      },
    });
  }
}

export interface Combo {
  value: any;
  label: string;
}
